var pug = require("!../../../../../aan/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (addWrapper, data, linkOpenAllinViewer, linkToContent, linkToViewer, linkToViewerAlt, renderCaption, renderContent, renderNotes, renderTitle) {let renderOrder = ['title', 'content', 'other', 'caption'];
pug_mixins["populateData"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ((linkOpenAllinViewer.enabled)) {
pug_html = pug_html + "\u003Cdiv class=\"text-right\"\u003E";
pug_mixins["link"](linkOpenAllinViewer, undefined);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
// iterate data
;(function(){
  var $$obj = data;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var item = $$obj[pug_index0];
pug_mixins["renderItem"](item, true, '0');
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var item = $$obj[pug_index0];
pug_mixins["renderItem"](item, true, '0');
    }
  }
}).call(this);

};
pug_mixins["renderItem"] = pug_interp = function(item, renderLinks, dataIndex, id){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (" class=\"figure\""+pug.attr("id", 'collateral-' + item.id, true, true)) + "\u003E";
// iterate renderOrder
;(function(){
  var $$obj = renderOrder;
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var order = $$obj[pug_index1];
switch (order){
case 'title':
pug_mixins["renderItemTitle"](item);
  break;
case 'content':
pug_mixins["renderItemContent"](item, dataIndex, id);
  break;
case 'caption':
pug_mixins["renderItemCaption"](item);
  break;
default:
pug_html = pug_html + (null == (pug_interp = item.unhandledData) ? "" : pug_interp);
  break;
}
      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var order = $$obj[pug_index1];
switch (order){
case 'title':
pug_mixins["renderItemTitle"](item);
  break;
case 'content':
pug_mixins["renderItemContent"](item, dataIndex, id);
  break;
case 'caption':
pug_mixins["renderItemCaption"](item);
  break;
default:
pug_html = pug_html + (null == (pug_interp = item.unhandledData) ? "" : pug_interp);
  break;
}
    }
  }
}).call(this);

if ((renderLinks)) {
pug_mixins["renderBottomLinks"](item);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["renderItemTitle"] = pug_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ((renderTitle && item.title)) {
pug_html = pug_html + "\u003Cdiv class=\"figure-heading\"\u003E" + (null == (pug_interp = item.title) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
};
pug_mixins["renderItemContent"] = pug_interp = function(item, dataIndex, id){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ((renderContent)) {
if ((item.multiFigure)) {
// iterate item.multiFigure
;(function(){
  var $$obj = item.multiFigure;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var figure = $$obj[index];
pug_mixins["renderItem"](figure, false, index, item.id);
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var figure = $$obj[index];
pug_mixins["renderItem"](figure, false, index, item.id);
    }
  }
}).call(this);

}
else {
if ((linkToViewerAlt.enabled)) {
pug_mixins["link"](linkToViewerAlt, undefined, item, dataIndex, item.modifiedContent);
}
else {
pug_html = pug_html + (null == (pug_interp = item.content) ? "" : pug_interp);
}
}
}
};
pug_mixins["renderItemCaption"] = pug_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (((renderCaption && item.caption) || (renderNotes && item.notes))) {
pug_html = pug_html + "\u003Cdiv class=\"figcaption\"\u003E";
if ((renderCaption)) {
pug_html = pug_html + (null == (pug_interp = item.caption) ? "" : pug_interp);
}
if ((renderNotes)) {
pug_html = pug_html + (null == (pug_interp = item.notes) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
};
pug_mixins["renderBottomLinks"] = pug_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ((linkToContent.enabled || linkToViewer.enabled)) {
pug_html = pug_html + "\u003Cdiv class=\"external-links\"\u003E";
if ((linkToContent.enabled)) {
pug_mixins["link"](linkToContent, '#'+item.id, item);
}
if ((linkToViewer.enabled)) {
pug_mixins["link"](linkToViewer, undefined, item, '0');
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
};
pug_mixins["link"] = pug_interp = function(link, href, item, dataIndex, content){
var block = (this && this.block), attributes = (this && this.attributes) || {};
const ariaLabel = link.ariaLabel && link.ariaLabel.replace(/##/g, item.title || 'figure')
const destination = href === undefined ? item ? 'core-fv-'+item.id : link.href : href
if ((href === undefined)) {
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes([link.classList], [true]), false, true)+pug.attr("data-target", destination, true, true)+pug.attr("data-index", dataIndex, true, true)+pug.attr("aria-label", ariaLabel, true, true)+" data-open=\"viewer\"") + "\u003E";
pug_mixins["linkContent"](link, content);
pug_html = pug_html + "\u003C\u002Fbutton\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (pug.attr("class", pug.classes([link.classList], [true]), false, true)+pug.attr("href", destination||link.href, true, true)+pug.attr("data-index", dataIndex, true, true)+pug.attr("aria-label", ariaLabel, true, true)) + "\u003E";
pug_mixins["linkContent"](link, content);
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
};
pug_mixins["linkContent"] = pug_interp = function(link, content){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ((link.prependIcon && link.icon)) {
pug_html = pug_html + "\u003Ci" + (pug.attr("class", pug.classes([link.icon], [true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003C\u002Fi\u003E";
}
if ((content)) {
pug_html = pug_html + (null == (pug_interp = content) ? "" : pug_interp);
}
else {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = link.text) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
if ((!link.prependIcon && link.icon)) {
pug_html = pug_html + "\u003Ci" + (pug.attr("class", pug.classes([link.icon], [true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003C\u002Fi\u003E";
}
};
if ((addWrapper)) {
pug_html = pug_html + "\u003Cdiv class=\"section--wrapper\"\u003E";
pug_mixins["populateData"]();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
else {
pug_mixins["populateData"]();
}}.call(this,"addWrapper" in locals_for_with?locals_for_with.addWrapper:typeof addWrapper!=="undefined"?addWrapper:undefined,"data" in locals_for_with?locals_for_with.data:typeof data!=="undefined"?data:undefined,"linkOpenAllinViewer" in locals_for_with?locals_for_with.linkOpenAllinViewer:typeof linkOpenAllinViewer!=="undefined"?linkOpenAllinViewer:undefined,"linkToContent" in locals_for_with?locals_for_with.linkToContent:typeof linkToContent!=="undefined"?linkToContent:undefined,"linkToViewer" in locals_for_with?locals_for_with.linkToViewer:typeof linkToViewer!=="undefined"?linkToViewer:undefined,"linkToViewerAlt" in locals_for_with?locals_for_with.linkToViewerAlt:typeof linkToViewerAlt!=="undefined"?linkToViewerAlt:undefined,"renderCaption" in locals_for_with?locals_for_with.renderCaption:typeof renderCaption!=="undefined"?renderCaption:undefined,"renderContent" in locals_for_with?locals_for_with.renderContent:typeof renderContent!=="undefined"?renderContent:undefined,"renderNotes" in locals_for_with?locals_for_with.renderNotes:typeof renderNotes!=="undefined"?renderNotes:undefined,"renderTitle" in locals_for_with?locals_for_with.renderTitle:typeof renderTitle!=="undefined"?renderTitle:undefined));;return pug_html;};
module.exports = template;